export default {
    state: {
        user: {
            fullname: ''
        }
    },
    getters: {
        fullname: state => {
            return state.user.fullname;
        }
    },
    mutations: {
        userUpdate (state, user) {
            state.user = user || {};
        }
    }
};